import { useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { isOktaEnabled } from "./oktaConfig";

interface Props {
  children: React.ReactNode;
}

// Wraps a route subtree and ensures the user is authenticated.
// If Okta isn't configured (open mode), this is a no-op pass-through.

export function RequireAuth({ children }: Props) {
  if (!isOktaEnabled()) {
    return <>{children}</>;
  }
  return <RequireOktaAuth>{children}</RequireOktaAuth>;
}

function RequireOktaAuth({ children }: Props) {
  const { authState, oktaAuth } = useOktaAuth();

  useEffect(() => {
    if (!authState) return;
    if (!authState.isAuthenticated) {
      // Sends the browser to Okta's authorize endpoint with PKCE.
      // After login Okta redirects to /login/callback, which exchanges
      // the code for tokens and routes back here.
      oktaAuth.signInWithRedirect();
    }
  }, [authState, oktaAuth]);

  if (!authState || !authState.isAuthenticated) {
    return <div>Signing in…</div>;
  }
  return <>{children}</>;
}
